var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDataSearch = function SvgDataSearch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.482 14.2665L3.5 16.4999V13.4999H2.5C2.23478 13.4999 1.98043 13.3945 1.79289 13.207C1.60536 13.0194 1.5 12.7651 1.5 12.4999V2.49988C1.5 2.23466 1.60536 1.98031 1.79289 1.79277C1.98043 1.60523 2.23478 1.49988 2.5 1.49988H15.5C15.7652 1.49988 16.0196 1.60523 16.2071 1.79277C16.3946 1.98031 16.5 2.23466 16.5 2.49988V7.49988",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4994 14.9999C13.4324 14.9999 14.9994 13.4329 14.9994 11.4999C14.9994 9.56688 13.4324 7.99988 11.4994 7.99988C9.56639 7.99988 7.99939 9.56688 7.99939 11.4999C7.99939 13.4329 9.56639 14.9999 11.4994 14.9999Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4993 16.4999L13.974 13.9746",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDataSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/data-search.b8f3a45b.svg";
export { ForwardRef as ReactComponent };